import { formatExpirationForCardType, parseLuxonYearMonthDay } from '@/components/concession/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import type { z } from 'zod';
import FormSection from '../../FormSection';
import { schema } from './ConcessionCard.schema';

type FormFields = z.infer<typeof schema>;

export type ConcessionCardProps = {
  defaultValues?: FormFields;
  onSubmit?: (data: FormFields) => void;
  isLoading?: boolean;
};

export const ConcessionCard = ({ defaultValues, onSubmit, isLoading }: ConcessionCardProps) => {
  const formatDate = () => {
    if (
      defaultValues?.expiryDay &&
      defaultValues?.expiryMonth &&
      defaultValues?.expiryYear &&
      defaultValues?.cardType
    ) {
      return formatExpirationForCardType(
        parseLuxonYearMonthDay(defaultValues.expiryYear, defaultValues.expiryMonth, defaultValues.expiryDay),
        defaultValues.cardType,
      );
    }
  };

  const formContext = useForm<FormFields>({
    values: {
      ...defaultValues,
      status:
        (defaultValues?.hasValidConcessionCard === true && 'Active') ||
        (defaultValues?.hasValidConcessionCard === false && 'Expired') ||
        '',
      expiration: formatDate(),
    },
    resolver: zodResolver(schema),
  });

  return (
    <FormSection title="Concession Card" formContext={formContext} onSubmit={onSubmit} isLoading={isLoading}>
      <FormContainer formContext={formContext}>
        <Grid container columnSpacing={10} rowSpacing={5} marginY={2} data-testid="concession-card-form">
          <Grid item xs={12} sm={12} lg={6}>
            <TextFieldElement name="cardNumber" label="Card Number" disabled={true} fullWidth />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <TextFieldElement name="cardType" label="Card Type" fullWidth disabled={true} />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <TextFieldElement name="status" label="Status" fullWidth disabled={true} />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <TextFieldElement name="expiration" label="Expiration" fullWidth disabled={true} />
          </Grid>
        </Grid>
      </FormContainer>
    </FormSection>
  );
};
